import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-800 rounded-full mb-3">
            专题聚焦
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            精选专题内容，带你深入探索漫画世界
          </p>
        </div>

        <div className="flex flex-col gap-5">
          {carouselData.map((item, idx) => (
            <div
              key={idx}
              className="group flex flex-col md:flex-row gap-5 md:gap-0 bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full md:w-72 lg:w-80 aspect-video md:aspect-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex-1 flex flex-col justify-center px-5 md:px-7 pb-5 md:pb-0">
                <h3 className="text-lg md:text-xl font-semibold text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
                <div className="mt-4">
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                    查看更多
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}